<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage" @change="getShowType">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码" v-if="showType == 1">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI" v-if="showType == 1">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="产品信息" v-if="showType == 1">
                            <c-input name="product_info" placeholder="品牌/型号/分类"></c-input>
                        </m-search-item>
                        <m-search-item label="采购单号" v-if="showType == 2">
                            <c-input name="purchase_code"></c-input>
                        </m-search-item>
                        <m-search-item label="供应商" v-if="showType == 2">
                            <c-select name="supplier_id" async  @search="searchSupplier" v-model="supplierId"></c-select>
                        </m-search-item>
                        <m-search-item label="供应商联系人" v-if="showType == 2">
                            <c-select name="supplier_contact_id" async  @search="searchUser('2', arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                        <m-search-item label="采购部门" v-if="showType == 2">
                            <c-select name="purchase_dept_id" async  @search="searchDepartment"></c-select>
                        </m-search-item>
                        <m-search-item label="采购人" v-if="showType == 2">
                            <c-select name="purchase_user_id" async  @search="searchUser('1', arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                        <m-search-item label="采购员" v-if="showType == 1">
                            <c-input name="purchase_user_name" placeholder="请输入采购员"></c-input>
                        </m-search-item>
                        <m-search-item label="验机人">
                            <c-input name="inspection_user_realname" placeholder="请输入验机人"></c-input>
                        </m-search-item>
                        <m-search-item label="等级" v-if="showType == 1">
                            <c-select name="level_type" :options="LEVEL_TYPE"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2" v-if="showType == 1">
                            <c-datetime range start-name="purchase_start_date" end-name="purchase_end_date"></c-datetime>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2" v-if="showType == 2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button color="main" v-if="auth('b_wait_storage_edit') && showType == 1"  prepend-icon="tf-add" @click="inStorageCode()">批量入库</c-button>
                    <c-button color="main" v-if="auth('b_wait_storage_edit') && showType == 2"  prepend-icon="tf-add" @click="inStoragePurchase()">批量入库</c-button>
                    <c-button v-if="auth('b_wait_storage_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--多选后操作栏切换为批量模式：显示已选条数并可取消勾选，按钮与常态操作栏保持一致-->
                <template #batchOperate>
                    <c-button color="main" v-if="auth('b_wait_storage_edit') && showType == 1"  prepend-icon="tf-add" @click="inStorageCode()">批量入库</c-button>
                    <c-button color="main" v-if="auth('b_wait_storage_edit') && showType == 2"  prepend-icon="tf-add" @click="inStoragePurchase()">批量入库</c-button>
                    <c-button v-if="auth('b_wait_storage_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <!--商品信息-->
                <template #product_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

                <!--采购价-->
                <template #purchase_price="{data}">
                    ￥{{data.purchase_price}}
                </template>
                <!--采购单状态-->
                <template #purchase_state="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_STATE" :value="data.purchase_state"></c-state>
                </template>
                <!--采购单类型-->
                <template #purchase_type="{data}">
                    <c-state tag async dict="PURCHASE_ORDER_TYPE" :value="data.purchase_type"></c-state>
                </template>
                <!--采购总价-->
                <template #purchase_money="{data}">
                    ￥{{data.purchase_money}}
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="120"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_wait_storage_edit') && showType == 1" icon="tf-in-stock" @click="inStorageCode(data)">入库</c-table-button>
                        <c-table-button v-if="auth('b_wait_storage_edit') && showType == 2" icon="tf-in-stock" @click="inStoragePurchase(data)">入库</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--批量入库弹窗-->
            <code-in-storage ref="codeInStorage" @resolve="$refs.view.update()"></code-in-storage>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import codeInStorage from "@/pages/storage/code_storage_in.vue";

export default {
    name: 'm_wait_storage',

    components: {codeInStorage},

    computed: {
        ...mapState(['saasInfo','userInfo']),
        ...asyncMapState(['LEVEL_TYPE'])
    },

    data() {
        return {
            defaultSearchData: {
                main_state:2,       //待入库
                wait_in_stock:1     //仅查询待入库数据
            },
            workType: 17,        //待入库商品列表
            showType:1,           //1=按商品展示  2=按采购单展示
            supplierId:0          //供应商ID
        }
    },
    methods: {
        /*******搜索分类*****************/
        getShowType(viewId) {
            this.request({
                url: '/sys_user_view/show_type/filte',
                data: {
                    view_id: viewId
                },
                success: data => {
                    this.showType = data||1;
                }
            })
        },
        /*******搜索【供应商】下拉框信息*****************/
        searchSupplier(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SUPPLIER',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索部门*****************/
        searchDepartment(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'DEPARTMENT',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            });
        },
        /************搜索用户*******************************/
        searchUser(user_type, keyword, resolve) {
            let paramData = {
                user_type: user_type,
                options_code: 'SYSUSER',
                keyword: keyword
            };
            this.request({
                url: '/system/options',
                data: paramData,
                success: data => {
                    resolve(data);
                }
            })
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /****条码入库****/
        inStorageCode(data) {
            let produce_unique_code_list = [];
            if (data){
                this.$confirm({
                    title: '确认入库商品【'+data.produce_unique_code+'】',
                    message: '是否确认将商品【' + [data.level_name, data.spu_model_name, data.memory_name, data.color_name].filter(Boolean).join(' ') + '】入库',  // 提示内容,
                    buttonName: '确定入库',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product/unique_code/instorage',
                            data: {
                                produce_unique_code_list:[data.produce_unique_code]
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    message: '入库成功',
                                    type: 'success'
                                });
                                //刷新
                                this.$refs.view.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {
                    },  // 取消按钮回调
                });
            }else {
                var list = this.$refs.view.$refs.list.getData('selected');
                if (list && list.length > 0) {
                    produce_unique_code_list = list.map(item => item.produce_unique_code);
                    this.$confirm({
                        title: '批量入库商品',
                        message: '是否确认将选中的【'+produce_unique_code_list.length+'】条记录，批量入库',  // 提示内容,
                        buttonName: '确定入库',  // 确定按钮文字
                        cancelButton: true,  // 是否显示取消按钮
                        resolve: () => {
                            this.request({
                                url: '/product/unique_code/instorage',
                                data: {
                                    produce_unique_code_list:produce_unique_code_list
                                },
                                loading: true,
                                success: data => {
                                    this.$message({
                                        message: '入库成功',
                                        type: 'success'
                                    });
                                    //刷新
                                    this.$refs.view.update();
                                }
                            });
                        },  // 确定按钮回调
                        cancel: () => {
                        },  // 取消按钮回调
                    });
                }else {
                    this.$refs.codeInStorage.open();
                }
            }
        },

        /****采购单入库****/
        inStoragePurchase(data) {
            let purchase_code_list = [];
            if (data){
                purchase_code_list.push(data.purchase_code);
            }else {
                var list = this.$refs.view.$refs.list.getData('selected');
                if (list && list.length > 0) {
                    purchase_code_list = list.map(item => item.purchase_code);
                }
            }
            this.$refs.codeInStorage.open(2,purchase_code_list);
        }
    }
}
</script>